"use client";
import { IBlocks } from "@/types";
import React from "react";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import ThemedStyles from "../style";

interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
}
export default function BlockDiv({ edit, block, update }: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    const dataAttributes = Object.fromEntries(
        Object.entries(blockUpdate.metadata || {})
            .filter(([key]) => key.startsWith("html-data-"))
            .map(([key, value]) => [
                `data-metadata-${key.replace("html-data-", "")}`,
                value,
            ])
    );
    return (
        <AdminPopover
            edit={edit}
            className={`pb-5 ${block.show ? "" : "opacity-30"}`}
            title={"Div Block"}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <ThemedStyles theme={{ css: blockUpdate.options.css } as any} />

            {edit ? (
                <div>
                    <p className="bg-user-primary-color text-center text-user-primary-text-color">
                        DIV BLOCK - This block will not be visible on your page
                    </p>
                    <p className="bg-user-primary-color text-center text-user-primary-text-color">
                        {JSON.stringify(dataAttributes)}
                    </p>
                    <div {...dataAttributes} />
                </div>
            ) : (
                <div {...dataAttributes} />
            )}
        </AdminPopover>
    );
}
